/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type ExtendedSearchGpsSearchTab_eventDates$ref: FragmentReference;
declare export opaque type ExtendedSearchGpsSearchTab_eventDates$fragmentType: ExtendedSearchGpsSearchTab_eventDates$ref;
export type ExtendedSearchGpsSearchTab_eventDates = {|
  +beginsAt: ?any,
  +endsAt: ?any,
  +$refType: ExtendedSearchGpsSearchTab_eventDates$ref,
|};
export type ExtendedSearchGpsSearchTab_eventDates$data = ExtendedSearchGpsSearchTab_eventDates;
export type ExtendedSearchGpsSearchTab_eventDates$key = {
  +$data?: ExtendedSearchGpsSearchTab_eventDates$data,
  +$fragmentRefs: ExtendedSearchGpsSearchTab_eventDates$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "ExtendedSearchGpsSearchTab_eventDates",
  "type": "Event",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "beginsAt",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "endsAt",
      "args": null,
      "storageKey": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '552a31835a4bb894208a9a0d6769ccae';

module.exports = node;
